(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.localStorage.getItem('announcementDismissed');

      if ( !ad ) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.localStorage.setItem("announcementDismissed", true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('.collapsible');
      this.content = this.querySelector('.accordion__content');
      this.transition = null;
      this.isClosing = false;
      this.isExpanding = false;

      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      this.transition = true;
      this.content.style.maxHeight = null;
      this.content.addEventListener('transitionend', () => {
        this.onTransitionFinish(false);
      }, { once: true });
    }

    open() {
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      this.transition = true;
      this.content.style.maxHeight = this.content.scrollHeight + "px";
      this.content.addEventListener('transitionend', () => {
        this.onTransitionFinish(true);
      }, { once: true });
    }

    onTransitionFinish(open) {
      this.details.open = open;
      this.transition = null;
      this.isClosing = false;
      this.isExpanding = false;
    }
  }

  customElements.define('collapsible-content', CollapsibleContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.onload = () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.localization-list'),
        inputSearch: this.querySelector('#localization-search-input'),
        closeButton: this.querySelector('.modal__close-button'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      if (this.elements.inputSearch) {
        this.elements.inputSearch.addEventListener('keyup', this.filter.bind(this));
      }

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    filter(event) {
      const valThis = event.target.value;
      this.elements.panel.querySelectorAll('.disclosure__item').forEach((item) => {
        const text = item.querySelector('.localization-form__country-name').textContent;
        const textMatch = text.toLowerCase().indexOf(valThis.toLowerCase()) > -1;
        textMatch ? item.classList.remove('hide') : item.classList.add('hide');
      });

      const activeItems = this.elements.panel.querySelectorAll('.disclosure__item:not(.hide)');
      const noResultsMessage = this.elements.panel.querySelector('.disclosure__no-results');

      if (!activeItems.length) {
        noResultsMessage.classList.remove('hide');
      } else if (!noResultsMessage.classList.contains('hide')) {
        noResultsMessage.classList.add('hide');
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.button.classList.remove('disclosure__button--open');
      this.elements.panel.setAttribute('hidden', true);
      document.body.classList.remove('overflow-hidden-mobile');
      document.body.removeEventListener('click', this.onBodyClick);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      this.elements.button.classList.toggle('disclosure__button--open');
      document.body.classList.add('overflow-hidden-mobile');
      document.body.addEventListener('click', this.onBodyClick);
    }

    handleBodyClick(evt) {
      const target = evt.target;
      const closestForm = target.closest('localization-form');

      if (target !== this && !target.closest('localization-form')) {
        this.hidePanel();
      } else if (closestForm !== this) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerHeight = this.header.offsetHeight;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      const backButton = this.header.querySelector('.header__back-button button');
      if (backButton) {
        const referrerUrl = document.referrer;
        const currentPathname = location.pathname;

        if (referrerUrl) {
          const createReferrerUrl = new URL(referrerUrl);
          const referrerPathname = createReferrerUrl.pathname;
          const referrerPathArray = referrerPathname.split('/');
          const currentpathArray = currentPathname.split('/');

          if (currentpathArray[currentpathArray.length - 1] !== referrerPathArray[referrerPathArray.length - 1]) {
            localStorage.setItem("archerReferredPath", referrerPathname);
            localStorage.setItem("archerReferredParams", createReferrerUrl.search);
            localStorage.setItem("archerCurrentPath", currentPathname);
          }
        }

        backButton.addEventListener('click', this.handleBackHistory.bind(this));
        return;
      }

      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.preventOpenSubmenu = false;
      this.openingMenu = false;
      this.closingMenu = false;
      this.listMenuItems.forEach(summary => summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach(summary => summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerWrap.dataset.pageType !== 'product') {
        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    handleBackHistory (event) {
      const historyLength = history.length;
      const backUrl = event.currentTarget.dataset.url;

      if (historyLength > 2) {
        history.back();
      } else {
        window.location.href = backUrl;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.top) {
        if ( !this.header.classList.contains('shopify-section-header-light') ) {
          this.header.classList.add('shopify-section-header-light');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerHeight) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerHeight) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-light');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-light', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-light', 'animate');
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item span');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open')) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      this.header.classList.add('shopify-section-header-light');

      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      window.clearTimeout(this.timeoutClose);
      this.closingMenu = true;

      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (!detailsElement) return;

      if ( !this.header.classList.contains('animate') ) {
        this.header.classList.remove('shopify-section-header-light');
      }

      detailsElement.classList.remove('sub-menu-opening');
      detailsElement.removeAttribute('open');
      // this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 300) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      }

      window.requestAnimationFrame(handleAnimation);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  window.onload = () => {
    setTimeout(() => {
      document.querySelector('.hero-media__video').dataset.ready = true;
    }, 1500);
  }

  const getYouTubeVideoIdFromUrl = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : undefined;
  };

  const getVimeoIdFromUrl = (url) => {
    const match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
      return match[1];
    }
  };

  class HeroMedia extends HTMLElement {
    constructor() {
      super();

      const youTubeVideo = this.querySelector('.js-youtube-background-video');
      const vimeoVideo = this.querySelector('.js-vimeo-background-video');
      const customVideo = this.querySelector('video.hero__media-custom-video');
      this.sectionId = this.dataset.sectionId;
      this.videoOverlay = this.querySelector('.js-video-overlay');

      if (youTubeVideo) {
        const bgVideoUrl = youTubeVideo.getAttribute('data-video');
        const bgVideoID = getYouTubeVideoIdFromUrl(bgVideoUrl);

        if (!bgVideoID) {
          return;
        }

        const defaults = {
          videoId: bgVideoID,
          playerVars: {
            autohide: 0,
            autoplay: 1,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            enablejsapi: 1,
            origin: routes.shop_url
          }
        };
        // API callback events
        defaults.events = {
          onReady: this.onPlayerReady.bind(this),
          onStateChange: this.onPlayerStateChange.bind(this)
        };

        this.options = defaults;
        this.ytPlayer;

        if (window.youTubeReady) {
          this.initVideo();
        } else {
          document.addEventListener('youTubeReady', this.initVideo.bind(this));
        }
      }

      if (vimeoVideo) {
        const defaults = {
          background: true,
          autoplay: true,
          byline: false,
          controls: false,
          loop: true,
          muted: true,
          playsinline: true,
          portrait: false,
          title: false
        };
        this.options = defaults;
        this.vimeoElm = document.getElementById(`vimeo-player-${this.sectionId}`);
        const bgVideoUrl = vimeoVideo.getAttribute('data-video');
        this.vimeoId = getVimeoIdFromUrl(bgVideoUrl);

        if (!this.vimeoId) {
          return;
        }

        if (window.vimeoReady) {
          this.initVimeoVideo();
        } else {
          window.vimeoApiReady();
          document.addEventListener('vimeoReady', this.initVimeoVideo.bind(this));
        }
      }

      if (customVideo) {
        customVideo.muted = true;

        const playPromise = customVideo.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {})
            .catch(() => {
              customVideo.play();
            });
        }
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.dataset.animate = true;
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '30px 0px 30px 0px'}).observe(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this.reloadVideo.bind(this));
        document.addEventListener("shopify:section:unload", this.reloadVideo.bind(this));
        document.addEventListener("shopify:section:reorder", this.reloadVideo.bind(this));
      }
    }

    reloadVideo () {
      if (window.youTubeReady ) {
        this.initVideo();
      }

      this.vimeoElm = document.getElementById(`vimeo-player-${this.sectionId}`);
      if (window.vimeoReady && this.vimeoElm) {
        this.initVimeoVideo();
      }
    }

    initVideo() {
      this.ytPlayer = new YT.Player(`yt-player-${this.sectionId}`, this.options);
    }

    onPlayerReady(event) {
      event.target.mute();
      event.target.playVideo();
      const videoDuration = event.target.getDuration();

      setInterval(function (){
        const videoCurrentTime = event.target.getCurrentTime();
        const timeDifference = videoDuration - videoCurrentTime;

        if (2 > timeDifference > 0) {
          event.target.seekTo(0);
        }
      }, 1000);
    }

    onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING && this.videoOverlay) {
        this.videoOverlay.classList.add('header__video-overlay--fadeOut');
      }
    }

    initVimeoVideo() {
      var args = this.options;
      args.id = this.vimeoId;

      this.vimeoPlayer = new Vimeo.Player(this.vimeoElm, args);
      this.vimeoPlayer.ready().then(this.vimeoPlayerReady.bind(this));
    }

    vimeoPlayerReady() {
      this.vimeoPlayer.setMuted(true);

      if (this.videoOverlay) this.videoOverlay.classList.add('header__video-overlay--fadeOut');

      if (this.vimeoPlayer && typeof this.vimeoPlayer.play === 'function') {
        this.vimeoPlayer.play();
      }
    }
  }

  customElements.define('hero-media', HeroMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  class ImageWithText extends HTMLElement {
    constructor() {
      super();
      const videoFeature = this.querySelector('video.feature-row__image');

      if (videoFeature) {
        videoFeature.muted = true;

        const playPromise = videoFeature.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {})
            .catch(() => {
              videoFeature.play();
            });
        }
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.dataset.animation = true;
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '200px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('image-with-text', ImageWithText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const sectionId = this.dataset.sectionId;
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Contact_${sectionId}-email-error`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function () {
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error')
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        existingEmailMsg.classList.add('hide');
      });

      if (searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector('#Contact_newsletter').scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', 'Contact_newsletter-email-error');
          inputEmailNewsletter.setAttribute('data_form_status', true);

          errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  class RichText extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.dataset.animation = true;
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('rich-text', RichText);

  } catch(e) { console.error(e); }
})();
})();
